import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/constants/query-keys'
import { type ISocietyLookup, societiesService } from '../services/society.services'

/**
 * Lookup mínimo ({ _id, id, name, company }) para selects dependientes
 * (proyectos, representantes, negociaciones, filtros de entregas). El listado
 * admin vive en use-societies-admin-query.ts.
 */
export const useSocietiesLookupQuery = (dependence = true) => {
  return useQuery<ISocietyLookup[]>({
    queryKey: queryKeys.societies.lookup(),
    queryFn: async () => {
      try {
        return await societiesService.getLookup()
      } catch (e) {
        console.error(e)
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}
